var render = function () {
  var _class;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.container] = true, _class[_vm.$style.active] = _vm.isActive, _class[_vm.$style.disabled] = _vm.isDisable, _class),
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    class: _vm.$style.wrapper
  }, [_c('div', {
    class: _vm.$style.content
  }, [_vm.paymentSystem ? _c('div', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 20,
      expression: "20"
    }],
    class: [_vm.$style.logo, _vm.$style[_vm.paymentSystem.type]]
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "overflow",
      rawName: "v-overflow:hidden",
      arg: "hidden"
    }]
  }, [_c('p', {
    class: _vm.$style.title,
    domProps: {
      "textContent": _vm._s(_vm.displayCardPan)
    }
  }), _c('p', {
    class: _vm.$style.description,
    domProps: {
      "textContent": _vm._s(_vm.description)
    }
  })])]), _vm.$scopedSlots.hasOwnProperty('action') ? _c('div', {
    class: _vm.$style.action
  }, [_vm._t("action", null, {
    "disabled": _vm.isDisable
  })], 2) : _vm._e()]), _vm.$scopedSlots.hasOwnProperty('additional') && !_vm.isDisable ? _c('div', {
    directives: [{
      name: "m-t",
      rawName: "v-m-t",
      value: 10,
      expression: "10"
    }]
  }, [_vm._t("additional", null, {
    "disabled": _vm.isDisable
  })], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }